/* unplugin-vue-components disabled */import { render } from "./yujipointlist.vue?vue&type=template&id=19a4c2c8&scoped=true"
import script from "./yujipointlist.vue?vue&type=script&lang=js"
export * from "./yujipointlist.vue?vue&type=script&lang=js"

import "./yujipointlist.vue?vue&type=style&index=0&id=19a4c2c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a4c2c8"]])

export default __exports__